import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import formatarData from '~js/formatar-data';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

async function normalizarParaAdicionar(solicitacao, tipos, motivos, rubricasSubrubricas, arquivosDiaria, arquivosPassagem, arquivosAdiantamento) {
  delete solicitacao.projeto;
  delete solicitacao.projetoMetaEtapa;

  let passagem = null;
  let diaria = null;
  let adiantamento = null;
  

  // solicitacao.quantidadePassagemIda = converterMoeda.paraDolar(solicitacao.quantidadePassagemIda);
  // solicitacao.valorPassagemIda = converterMoeda.paraDolar(solicitacao.valorPassagemIda);
  // solicitacao.quantidadePassagemVolta = converterMoeda.paraDolar(solicitacao.quantidadePassagemVolta);
  // solicitacao.valorPassagemVolta = converterMoeda.paraDolar(solicitacao.valorPassagemVolta);
  // solicitacao.valorUnitarioDiaria = converterMoeda.paraDolar(solicitacao.valorUnitarioDiaria);
  // solicitacao.valorAdiantamento = converterMoeda.paraDolar(solicitacao.valorAdiantamento);
  // solicitacao.quantidadeDiaria = converterMoeda.paraDolar(solicitacao.quantidadeDiaria);
  // solicitacao.taxaEmbarque = converterMoeda.paraDolar(solicitacao.taxaEmbarque);
  // solicitacao.descontoAlimentacao = converterMoeda.paraDolar(solicitacao.descontoAlimentacao);

  if (solicitacao.dataNascimento) {
    solicitacao.dataNascimento = await formatarData.paraNumero(solicitacao.dataNascimento);
  }
  if (solicitacao.dataPagamento) {
    solicitacao.dataPagamento = await formatarData.paraNumero(solicitacao.dataPagamento);
  }
  if (solicitacao.dataIda) {
    solicitacao.dataIda = await formatarData.paraNumero(solicitacao.dataIda);
  }
  if (solicitacao.dataVolta) {
    solicitacao.dataVolta = await formatarData.paraNumero(solicitacao.dataVolta);
  }
  
  const exibirRubricaSubrubricaSolicitacaoWeb = Vue.storage.configuracao().exibirRubricaSubrubricaSolicitacaoWeb;
  
  if (tipos.adiantamento) {
    adiantamento = JSON.parse(JSON.stringify(Object.assign(solicitacao, {
      tipoReembolso: 2,
      motivoAdiantamento: motivos.adiantamento,
    })));
    
    if (exibirRubricaSubrubricaSolicitacaoWeb) {
      adiantamento.idRubrica = rubricasSubrubricas.adiantamento.idRubrica;
      adiantamento.idSubrubrica = rubricasSubrubricas.adiantamento.idSubrubrica;
    }
    
    limparCamposDiaria(adiantamento);
    limparCamposPassagem(adiantamento);
  }
  
  if (tipos.diaria) {
    diaria = JSON.parse(JSON.stringify(Object.assign(solicitacao, {
      tipoReembolso: 1,
      motivoAdiantamento: motivos.diaria,
    })));

    if (exibirRubricaSubrubricaSolicitacaoWeb) {
      diaria.idRubrica = rubricasSubrubricas.diaria.idRubrica;
      diaria.idSubrubrica = rubricasSubrubricas.diaria.idSubrubrica;
    }
    
    limparCamposAdiantamento(diaria);
    limparCamposPassagem(diaria);
  }
  
  if (tipos.passagem) {
    passagem = JSON.parse(JSON.stringify(Object.assign(solicitacao, {
      tipoReembolso: 0,
      motivoAdiantamento: motivos.passagem,
    })));

    if (exibirRubricaSubrubricaSolicitacaoWeb) {
      passagem.idRubrica = rubricasSubrubricas.passagem.idRubrica;
      passagem.idSubrubrica = rubricasSubrubricas.passagem.idSubrubrica;
    }
    
    limparCamposAdiantamento(passagem);
    limparCamposDiaria(passagem);
  }

  let solicitacoes = {};
  
  if (tipos.diaria) {
    solicitacoes.diaria = diaria;
    solicitacoes.arquivosDiaria = arquivosDiaria;
  }
  if (tipos.passagem) {
    solicitacoes.passagem = passagem;
    solicitacoes.arquivosPassagem = arquivosPassagem;
  }
  if (tipos.adiantamento) {
    solicitacoes.adiantamento = adiantamento;
    solicitacoes.arquivosAdiantamento = arquivosAdiantamento;
  }
  
  return solicitacoes;
}

async function normalizarParaAlterar(solicitacao, tipos, motivos, rubricasSubrubricas) {
  delete solicitacao.projeto;
  delete solicitacao.projetoMetaEtapa;
  
  // solicitacao.quantidadePassagemIda = converterMoeda.paraDolar(solicitacao.quantidadePassagemIda);
  // solicitacao.valorPassagemIda = converterMoeda.paraDolar(solicitacao.valorPassagemIda);
  // solicitacao.quantidadePassagemVolta = converterMoeda.paraDolar(solicitacao.quantidadePassagemVolta);
  // solicitacao.valorPassagemVolta = converterMoeda.paraDolar(solicitacao.valorPassagemVolta);
  // solicitacao.valorUnitarioDiaria = converterMoeda.paraDolar(solicitacao.valorUnitarioDiaria);
  // solicitacao.valorAdiantamento = converterMoeda.paraDolar(solicitacao.valorAdiantamento);
  // solicitacao.quantidadeDiaria = converterMoeda.paraDolar(solicitacao.quantidadeDiaria);
  // solicitacao.taxaEmbarque = converterMoeda.paraDolar(solicitacao.taxaEmbarque);
  // solicitacao.descontoAlimentacao = converterMoeda.paraDolar(solicitacao.descontoAlimentacao);

  if (solicitacao.dataNascimento) {
    solicitacao.dataNascimento = await formatarData.paraNumero(solicitacao.dataNascimento);
  }
  if (solicitacao.dataPagamento) {
    solicitacao.dataPagamento = await formatarData.paraNumero(solicitacao.dataPagamento);
  }
  if (solicitacao.dataIda) {
    solicitacao.dataIda = await formatarData.paraNumero(solicitacao.dataIda);
  }
  if (solicitacao.dataVolta) {
    solicitacao.dataVolta = await formatarData.paraNumero(solicitacao.dataVolta);
  }

  const exibirRubricaSubrubricaSolicitacaoWeb = Vue.storage.configuracao().exibirRubricaSubrubricaSolicitacaoWeb;

  if (tipos.passagem) {
    solicitacao.motivoAdiantamento = motivos.passagem;

    if (exibirRubricaSubrubricaSolicitacaoWeb) {
      solicitacao.idRubrica = rubricasSubrubricas.passagem.idRubrica;
      solicitacao.idSubrubrica = rubricasSubrubricas.passagem.idSubrubrica;
    }
  } else if (tipos.diaria) {
    solicitacao.motivoAdiantamento = motivos.diaria;

    if (exibirRubricaSubrubricaSolicitacaoWeb) {
      solicitacao.idRubrica = rubricasSubrubricas.diaria.idRubrica;
      solicitacao.idSubrubrica = rubricasSubrubricas.diaria.idSubrubrica;
    }
  } else {
    solicitacao.motivoAdiantamento = motivos.adiantamento;

    if (exibirRubricaSubrubricaSolicitacaoWeb) {
      solicitacao.idRubrica = rubricasSubrubricas.adiantamento.idRubrica;
      solicitacao.idSubrubrica = rubricasSubrubricas.adiantamento.idSubrubrica;
    }
  }
}

function limparCamposDiaria(solicitacao) {
  delete solicitacao.quantidadeDiaria;
  delete solicitacao.valorUnitarioDiaria;
  delete solicitacao.taxaEmbarque;
  delete solicitacao.descontoAlimentacao;
}

function limparCamposPassagem(solicitacao) {
  delete solicitacao.quantidadePassagemIda;
  delete solicitacao.valorPassagemIda;
  delete solicitacao.indicacaoFornecedor;
}

function limparCamposAdiantamento(solicitacao) {
  delete solicitacao.valorAdiantamento;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/solicitacaoreembolsos', { params: parametros });
  },
  adicionar: async (solicitacao, tipos, motivos, rubricasSubrubricas, arquivosDiaria, arquivosPassagem, arquivosAdiantamento) => {
    let solicitacoes = await normalizarParaAdicionar(solicitacao, tipos,  motivos, rubricasSubrubricas, arquivosDiaria, arquivosPassagem, arquivosAdiantamento);

    solicitacoes = await converterObjetoFormData(solicitacoes);

    return Vue.http.post('/api/solicitacaoreembolsos', solicitacoes).then(res => res.data);
  },
  alterar: async (solicitacao, tipos, motivos, rubricasSubrubricas, arquivos, id) => {
    await normalizarParaAlterar(solicitacao, tipos,  motivos, rubricasSubrubricas);
    solicitacao.arquivos = arquivos;
    
    solicitacao = await converterObjetoFormData(solicitacao);
    
    return Vue.http.put(`/api/solicitacaoreembolsos/${id}`, solicitacao).then(res => res.data.id);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/solicitacaoreembolsos/${id}`)
      .then(response => response.data);
  },
  relatorio: id => {
    return Vue.http.get(`/api/solicitacaoreembolsos/${id}/relatorio`)
      .then(response => response.data);
  },
  liberar: id => {
    return Vue.http.post(`/api/solicitacaoreembolsos/${id}/liberar`)
      .then(response => response.data);
  },
  cancelar: id => {
    return Vue.http.post(`/api/solicitacaoreembolsos/${id}/cancelar`)
      .then(response => response.data);
  },
  reenviarEmail: id => {
    return Vue.http.get(`/api/solicitacaoreembolsos/${id}/reenviaremail`)
      .then(response => response.data);
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaoreembolsos/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/solicitacaoreembolsos/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
    .then(response => {
      return salvarArquivo(response, arquivo);
    });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-reembolso-estrangeiro/servico.js